import { buildProps } from '@element-plus/utils'
import { componentSizes } from '@element-plus/constants'
import type { ExtractPropTypes, PropType } from 'vue'
import type SkeletonTable from './skeleton-table.vue'

export type StyleMap = Record<string, any>

export interface CellDescriptor {
  colspan?: number
  rowspan?: number
}

export interface CustomCellRenderFunction {
  (row: number, col: number): CellDescriptor
}

export const skeletonTableProps = buildProps({
  /**
   * @description Number of table rows
   */
  rows: {
    type: Number,
    default: 1,
    validator: (val) => Number.parseInt(val, 10) > 0,
  },
  /**
   * @description Number of table columns.
   */
  cols: {
    type: [Number, Array],
    default: 4,
    validator: (val) =>
      (Array.isArray(val) && val.length > 0) ||
      (!Array.isArray(val) && Number.parseInt(val, 10) > 0),
  },
  /**
   * @description Show the header of table
   */
  header: {
    type: Boolean,
    default: true,
  },
  /**
   * @description Show the footer of table
   */
  footer: {
    type: Boolean,
    default: false,
  },
  /**
   * @description Show the title of table
   */
  caption: {
    type: Boolean,
    default: false,
  },
  /**
   * @description Show the border of table
   */
  border: {
    type: Boolean,
    default: false,
  },
  /**
   * @description Custom height of table cell
   */
  cellHeight: {
    type: Number,
    validator: (val) =>
      typeof val === 'undefined' || Number.parseInt(val, 10) > 0,
  },
  /**
   * @description table header with background
   */
  background: {
    type: Boolean,
    default: false,
  },
  /**
   * @description Size of table
   */
  size: {
    type: String,
    values: componentSizes,
    default: 'default',
  },
  /**
   * @description Custom cell merge
   */
  customCellRender: {
    type: Function as PropType<CustomCellRenderFunction>,
  },
} as const)
export type SkeletonTableProps = ExtractPropTypes<typeof skeletonTableProps>

export type SkeletonTableInstance = InstanceType<typeof SkeletonTable>
